import React, { useState, useEffect } from 'react'
import GitJournal from './gitJournal';

export const GithubStats = () => {
  const personalAccountUsername = 'vimohbjj';
  const [stats, setStats] = useState({
    repos: 0,
    contributions: 0,
    followers: 0,
    thisYearContributions: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllAccounts();
  }, []);

  const fetchAllAccounts = async () => {
    try {
      const usernames = ["vimohbjj", "vicenzomh"];
      
      const results = await Promise.all(
        usernames.map(username => fetchUserStats(username))
      );

      const totals = results.reduce((acc, result) => ({
        repos: acc.repos + result.repos,
        contributions: acc.contributions + result.contributions,
        thisYearContributions: acc.thisYearContributions + result.thisYearContributions,
        followers: acc.followers + result.followers
      }), { repos: 0, contributions: 0, thisYearContributions: 0, followers: 0 });

      setStats(totals);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching GitHub stats:', error);
      setLoading(false);
    }
  };

  const fetchUserStats = async (username) => {
    const userResponse = await fetch(`https://api.github.com/users/${username}`);
    const userData = await userResponse.json();

    const contribResponse = await fetch(
      `https://github-contributions-api.jogruber.de/v4/${username}`
    );
    const contribData = await contribResponse.json();

    const currentYear = new Date().getFullYear();

    const totalContributions = Object.values(contribData.total).reduce(
      (sum, yearTotal) => sum + yearTotal,
      0
    );

    return {
      repos: userData.public_repos,
      contributions: totalContributions,
      thisYearContributions: contribData.total[currentYear] || 0,
      followers: userData.followers
    };
  };

  return (
    <section className='grid grid-cols-1 gap-12 text-white bg-color-dark border-2 border-color-gray py-10'>

      <h3 className='text-3xl font-semibold text-green-800 mb-3 text-center'>
        GITHUB
      </h3>

      <div className=' flex flex-col gap-12 justify-evenly'>

        <article className='hidden sm:flex flex-col justify-center items-center '>
          <img className='w-11/12 p-5 border-4 rounded-lg border-green-700'
            src={`https://ghchart.rshah.org/3fb950/${personalAccountUsername}`}
            alt="GitHub Contributions"
          />
        </article>

        <article className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 text-center gap-8 md:gap-3 myBorder'>

          <span className='lg:col-span-1 lg:col-start-2 lg:col-end-3 py-4'>
            <h3 className='text-2xl sm:text-3xl md:text-4xl'> {loading ? '⏳' : stats.repos}  </h3>
            <p>Repositories</p>
          </span>

          <span className='lg:col-span-1 lg:col-start-3 lg:col-end-4 xl:col-start-4 xl:col-end-5 py-4 '>
            <h3 className='text-2xl sm:text-3xl md:text-4xl'>{loading ? '⏳' : stats.contributions.toLocaleString()}</h3>
            <p>Total Contributions</p>
          </span>

          <span className='lg:col-span-1 lg:col-start-4 lg:col-end-5 xl:col-start-6 xl:col-end-7 py-4 '>
            <h3 className='text-2xl sm:text-3xl md:text-4xl'> {loading ? '⏳' : stats.followers}</h3>
            <p>Followers</p>
          </span>

        </article>
      </div>
    </section>
  )
}

export default GithubStats